var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaid({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2432 8.67252L7.57495 4.36144L7.57495 18.1103C7.57495 18.7009 7.09077 19.1809 6.495 19.1809C5.89923 19.1809 5.41506 18.7009 5.41506 18.1103L5.41505 4.36144L1.74684 8.67252C1.39406 9.08649 0.769488 9.14003 0.351908 8.79029C-0.0656706 8.44055 -0.119668 7.82136 0.233114 7.40738L5.73904 0.937204C5.92803 0.71594 6.20342 0.589249 6.495 0.589249C6.78659 0.589249 7.06377 0.71594 7.25096 0.937204L12.7569 7.40738C13.1097 7.82136 13.0557 8.44055 12.6381 8.79029C12.2205 9.14003 11.5959 9.08649 11.2432 8.67252Z",
    fill: "#FF004F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7667 17.6819L18.2607 24.152C18.0717 24.3733 17.7964 24.5 17.5048 24.5C17.2132 24.5 16.936 24.3733 16.7488 24.152L11.2429 17.6819C10.8901 17.2679 10.9441 16.6487 11.3617 16.299C11.7793 15.9492 12.4038 16.0028 12.7566 16.4167L16.4248 20.7278V17.5241C16.4248 16.9335 16.909 16.4535 17.5048 16.4535C18.1005 16.4535 18.5847 16.9335 18.5847 17.5241V20.7278L22.2529 16.4167C22.4491 16.1865 22.7281 16.0688 23.0107 16.0688C23.2357 16.0688 23.4625 16.1455 23.6479 16.3007C24.0654 16.6505 24.1194 17.2697 23.7667 17.6836V17.6819Z",
    fill: "#E1E7EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5057 6.28064C16.91 6.28064 16.4258 5.80064 16.4258 5.21001V1.5706C16.4258 0.979971 16.91 0.499971 17.5057 0.499971C18.1015 0.499971 18.5857 0.979971 18.5857 1.5706V5.21001C18.5857 5.80064 18.1015 6.28064 17.5057 6.28064Z",
    fill: "#E1E7EF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5057 14.7922C16.91 14.7922 16.4258 14.3122 16.4258 13.7216V9.01439C16.4258 8.42376 16.91 7.94376 17.5057 7.94376C18.1015 7.94376 18.5857 8.42376 18.5857 9.01439V13.7216C18.5857 14.3122 18.1015 14.7922 17.5057 14.7922Z",
    fill: "#E1E7EF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49596 20.9455C7.09173 20.9455 7.57591 21.4255 7.57591 22.0161V23.3669C7.57591 23.9575 7.09173 24.4375 6.49596 24.4375C5.90019 24.4375 5.41602 23.9575 5.41602 23.3669V22.0161C5.41602 21.4255 5.90019 20.9455 6.49596 20.9455Z",
    fill: "#FF004F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaid);
export default __webpack_public_path__ + "static/media/paid.64eab84e.svg";
export { ForwardRef as ReactComponent };